
class device {
    static getCurrentDevice() {
        return "pc";
    }
}

export default device


// WEBPACK FOOTER //
// ./src/utility/Device.js